export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '2933f90c-91de-4109-8ef2-d639a15a6a25';
export const MODAL_CLOSE_SEC = 2.5;
